module.exports = __webpack_public_path__ + "img/8.a14b8efe.svg";